/* Extra keepers — drawer behaviour. HEllO EDC (India store). Added 9 Sep 2026.

   Ported from the international store, where this lives inline at the bottom of
   layout/theme.liquid. Same behaviour, two deliberate changes:

   1. The international copy hard-codes Easify's option IDs
      (371d277d-… for REBEL KEEPERS, 8ff1c3a9-… for FLEXA KEEPERS). Those IDs
      are issued per store, so they are meaningless here. This version finds
      each option by its visible label instead, then tags the element with a
      stable class of our own. It therefore works on either store unchanged.

   2. The CSS keys off that class rather than the option IDs — see
      assets/wc-keepers-drawer.css.

   WHAT IT DOES

   Easify renders the keepers picker as a plain block in the product form,
   sitting outside the row of variant buttons. On mobile that reads as a
   loose control with no relationship to the rest of the selection. This
   script adds a button to the variant button row for each keepers option and
   turns Easify's block into a bottom sheet that the button opens — so keepers
   behave like every other choice on the page.

   It only ever moves presentation around. The Easify inputs are untouched, so
   the line item properties it posts are exactly what they would have been.

   If a label is not found the script logs once and does nothing, leaving
   Easify's own block visible and usable. */

(function () {
  'use strict';

  if (window.__wcKeepersDrawer) return;
  window.__wcKeepersDrawer = true;

  var CONFIGS = [
    { label: 'REBEL KEEPERS', optionIndex: '3', drawerId: 'rebel-keepers-drawer' },
    { label: 'FLEXA KEEPERS', optionIndex: '4', drawerId: 'flexa-keepers-drawer' }
  ];

  var STATE = {};        /* drawerId -> chosen value, for the button caption */
  var warned = {};
  var backdrop = null;

  /* ---------- finding Easify's block ---------- */

  function resolve(config) {
    /* Already tagged on an earlier pass. */
    var known = document.getElementById(config.drawerId);
    if (known) return known;

    var roots = document.querySelectorAll('.po-option-root[data-option-id]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (root.id && root.id !== config.drawerId) continue;   /* claimed by another config */
      var text = (root.textContent || '').toUpperCase();
      if (text.indexOf(config.label) === -1) continue;
      root.id = config.drawerId;
      root.classList.add('wc-keepers-drawer');
      return root;
    }

    if (!warned[config.label] && roots.length) {
      warned[config.label] = true;
      if (window.console && console.info) {
        console.info('[WC] keepers: no option matching "' + config.label +
          '" on this product — leaving Easify’s own layout in place.');
      }
    }
    return null;
  }

  function triggerFor(config) {
    return document.querySelector('[aria-controls="' + config.drawerId + '"]');
  }

  function configForDrawerId(id) {
    for (var i = 0; i < CONFIGS.length; i++) {
      if (CONFIGS[i].drawerId === id) return CONFIGS[i];
    }
    return null;
  }

  /* ---------- open / close ---------- */

  function ensureBackdrop() {
    if (backdrop && document.body.contains(backdrop)) return backdrop;
    backdrop = document.querySelector('.rebel-keepers-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'rebel-keepers-backdrop';
      document.body.appendChild(backdrop);
    }
    return backdrop;
  }

  function closeAll() {
    CONFIGS.forEach(function (config) {
      var drawer = document.getElementById(config.drawerId);
      if (drawer) drawer.classList.remove('is-open');
      var trigger = triggerFor(config);
      if (trigger) trigger.classList.remove('is-selected');
    });
    ensureBackdrop().classList.remove('is-open');
  }

  function open(config) {
    var drawer = document.getElementById(config.drawerId);
    if (!drawer) return;
    closeAll();
    drawer.classList.add('is-open');
    ensureBackdrop().classList.add('is-open');
    var trigger = triggerFor(config);
    if (trigger) trigger.classList.add('is-selected');
  }

  /* ---------- the trigger button ---------- */

  function caption(config) {
    /* 13 Oct 2026: on a product with a keepers count (wc-keepers-rule.js),
       the caption shows progress — "Choose 2", "1 of 2", then the colours —
       instead of only the last colour tapped. */
    var rule = window.__wcKeepers;
    if (rule && typeof rule.caption === 'function' && rule.applies()) return rule.caption();
    return STATE[config.drawerId] || 'Select';
  }

  function updateCaption(config) {
    var trigger = triggerFor(config);
    if (!trigger) return;
    var value = trigger.querySelector('.mobile-variant-btn__value-option');
    if (value) value.textContent = caption(config);
  }

  function build(config, grid) {
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'mobile-variant-btn mobile-variant-btn--rebel-keepers';
    trigger.setAttribute('data-option-index', config.optionIndex);
    trigger.setAttribute('aria-label', 'Select ' + config.label);
    trigger.setAttribute('aria-controls', config.drawerId);

    var label = document.createElement('span');
    label.className = 'mobile-variant-btn__label';
    label.textContent = config.label;

    var value = document.createElement('span');
    value.className = 'mobile-variant-btn__value-option';
    value.setAttribute('data-option-index', config.optionIndex);
    value.textContent = caption(config);

    trigger.appendChild(label);
    trigger.appendChild(value);
    grid.appendChild(trigger);
  }

  function render() {
    var grid = document.querySelector('.mobile-variant-buttons-grid');
    if (!grid) return;

    CONFIGS.forEach(function (config) {
      if (!resolve(config)) return;
      if (triggerFor(config)) {
        updateCaption(config);
      } else {
        build(config, grid);
      }
    });
  }

  /* ---------- wiring ---------- */

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('button[aria-controls]');
    if (trigger) {
      var config = configForDrawerId(trigger.getAttribute('aria-controls'));
      if (config) {
        var drawer = document.getElementById(config.drawerId);
        if (drawer && drawer.classList.contains('is-open')) closeAll();
        else open(config);
        return;
      }
    }

    /* Picking a swatch inside the sheet updates the button caption. The sheet
       is left open on purpose — matches the international behaviour, so a
       shopper can compare without it closing under them. */
    var img = e.target.closest && e.target.closest('img.po-imageOption-swatch');
    if (img && img.alt) {
      var root = img.closest('.po-option-root[data-option-id]');
      if (root && root.id) {
        var cfg = configForDrawerId(root.id);
        if (cfg) {
          STATE[cfg.drawerId] = img.alt;
          updateCaption(cfg);
          return;
        }
      }
    }

    if (e.target === backdrop) closeAll();
  });

  function start() {
    ensureBackdrop();
    render();

    /* Easify injects its block asynchronously and the variant picker re-renders
       on every variant change, so keep re-checking rather than assuming one
       pass is enough. */
    var wrapper = document.querySelector('.product__info-wrapper');
    if (wrapper) {
      var settle = null;
      var observer = new MutationObserver(function () {
        clearTimeout(settle);
        settle = setTimeout(render, 50);
      });
      observer.observe(wrapper, { childList: true, subtree: true });
    }

    var tries = 0;
    var poll = setInterval(function () {
      render();
      if (++tries >= 10) clearInterval(poll);
    }, 500);
  }

  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
